
import React, { useState } from 'react';
import { PhaseCard } from './PhaseCard';
import { cn } from '@/lib/utils';

export interface Phase {
  id: string;
  title: string;
  description: string;
  isCompleted?: boolean;
  className?: string;
}

export interface PhaseTimelineProps {
  phases: Phase[];
  currentPhaseId: string;
  onPhaseSelect?: (phaseId: string) => void;
  selectedPhaseId?: string;
  className?: string;
}

export const PhaseTimeline = ({ 
  phases, 
  currentPhaseId,
  onPhaseSelect,
  selectedPhaseId,
  className 
}: PhaseTimelineProps) => {
  const handlePhaseClick = (phaseId: string) => {
    if (onPhaseSelect) {
      onPhaseSelect(phaseId);
    }
  };

  return (
    <div className={cn("transition-all duration-300", className)}>
      <div className="grid grid-cols-1 gap-3">
        {phases.map((phase, index) => (
          <PhaseCard
            key={phase.id}
            title={phase.title}
            description={phase.description}
            number={index + 1}
            isActive={phase.id === currentPhaseId}
            isSelected={phase.id === selectedPhaseId}
            isCompleted={phase.isCompleted}
            className={cn(
              phase.className,
              "transition-all duration-300",
              phase.id === selectedPhaseId && "scale-[1.02]"
            )}
            onClick={() => handlePhaseClick(phase.id)}
          />
        ))}
      </div>
    </div>
  );
};
